import { render, staticRenderFns } from "./showInActiveHospital.vue?vue&type=template&id=201f5ef4"
import script from "./showInActiveHospital.vue?vue&type=script&lang=js"
export * from "./showInActiveHospital.vue?vue&type=script&lang=js"
import style0 from "./showInActiveHospital.vue?vue&type=style&index=0&id=201f5ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports